/*
 * TeacherDetails Messages
 *
 * This contains all the text for the TeacherDetails component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
    header: {
        id: 'app.components.TeacherDetails.header',
        defaultMessage: 'This is the TeacherDetails component !'
    },
    teacherDetails: {
        id: 'app.components.TeacherDetails.teacherDetails',
        defaultMessage: 'Teacher details'
    },
    title: {
        id: 'app.components.TeacherDetails.title',
        defaultMessage: 'TITLE'
    },
    firstname: {
        id: 'app.components.TeacherDetails.firstname',
        defaultMessage: 'FIRST NAME'
    },
    lastname: {
        id: 'app.components.TeacherDetails.lastname',
        defaultMessage: 'SURNAME'
    },
    emailaddress: {
        id: 'app.components.TeacherDetails.emailaddress',
        defaultMessage: 'EMAIL'
    },
    username: {
        id: 'app.components.TeacherDetails.username',
        defaultMessage: 'USERNAME'
    },
    password: {
        id: 'app.components.TeacherDetails.password',
        defaultMessage: 'PASSWORD'
    },
    warning: {
        id: 'app.components.TeacherDetails.warning',
        defaultMessage: 'Username and password is used across all resources'
    },
    passwordWarning: {
        id: 'app.components.TeacherDetails.passwordWarning',
        defaultMessage: 'Please ensure the new teacher password is at least 8 characters long and contains both letters and numbers'
    },
    downloadSignInCard: {
        id: 'app.components.TeacherDetails.downSignInCard',
        defaultMessage: 'Download sign-in card'
    },
    adminPassword: {
        id: 'app.components.TeacherDetails.adminPassword',
        defaultMessage: 'ADMIN PASSWORD'
    },
    newTeacherPassword: {
        id: 'app.components.TeacherDetails.newTeacherPassword',
        defaultMessage: 'NEW TEACHER PASSWORD'
    },
    repeatTeacherPassword: {
        id: 'app.components.TeacherDetails.repeatTeacherPassword',
        defaultMessage: 'CONFIRM TEACHER PASSWORD'
    },
    resetTeacherPassword: {
        id: 'app.components.TeacherDetails.resetTeacherPassword',
        defaultMessage: 'Reset teacher password'
    },
    teacherPasswordLink: {
        id: 'app.components.TeacherDetails.teacherPasswordLink',
        defaultMessage: 'Send teacher password link'
    },
    teacherVerifyEmailLink: {
        id: 'app.components.TeacherDetails.teacherVerifyEmailLink',
        defaultMessage: 'Send verify email link'
    },
    emailUnverified: {
        id: 'app.components.TeacherDetails.emailUnverified',
        defaultMessage: 'Email unverified'
    },
    downloading: {
        id: 'app.components.TeacherDetails.downloading',
        defaultMessage: 'descargando'
    }
});



// WEBPACK FOOTER //
// ./app/components/teacher-details/messages.js